import { Suspense } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import LayoutIndex from '@/components/Layout'
import AvatarMarket from '@/views/avatar-market'
import Clone from '@/views/clone'
import CreateVideo from '@/views/create-video'
import Home from '@/views/home/index'
import InteractiveAvatar from '@/views/interactive-avatar'
import Invite from '@/views/invite'
import Login from '@/views/login'
import Mobile from '@/views/mobile'
import Promoter from '@/views/promoter'
import Setting from '@/views/setting'
import Video from '@/views/video/index'
import VoiceMarket from '@/views/voice-market'

export const rootRouter = [
  {
    path: '/mobile',
    element: <Mobile />,
    meta: {
      requiresAuth: false,
      title: '移动端访问'
    }
  },
  {
    path: '/login',
    element: <Login />,
    meta: {
      requiresAuth: false,
      title: '登录页'
    }
  },
  {
    path: '/create-video',
    element: <CreateVideo />,
    meta: {
      requiresAuth: false,
      title: '创建作品'
    }
  },
  {
    path: '/create-video/:avatarId',
    element: <CreateVideo />,
    meta: {
      requiresAuth: false,
      title: '创建作品'
    }
  },
  {
    path: '/digital',
    element: <InteractiveAvatar />,
    meta: {
      requiresAuth: true,
      title: '实时互动数字人'
    }
  },
  {
    element: <LayoutIndex />,
    children: [
      {
        path: '/',
        element: (
          <Suspense>
            <Home />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '首页'
        }
      },
      {
        path: '/p/:promoterCode',
        element: (
          <Suspense>
            <Home />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '首页'
        }
      },
      {
        path: '/i/:inviteCode',
        element: (
          <Suspense>
            <Home />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '首页'
        }
      },
      {
        path: '/home',
        element: (
          <Suspense>
            <Home />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '首页'
        }
      },
      {
        path: '/clone',
        element: (
          <Suspense>
            <Clone />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '声音克隆'
        }
      },
      {
        path: '/market/voice',
        element: (
          <Suspense>
            <VoiceMarket />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '声音市场'
        }
      },
      {
        path: '/market/digital',
        element: (
          <Suspense>
            <AvatarMarket />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '数字人市场'
        }
      },
      {
        path: '/avatar-market',
        element: (
          <Suspense>
            <AvatarMarket />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '数字人市场'
        }
      },
      {
        path: '/video',
        element: (
          <Suspense>
            <Video />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '视频'
        }
      },
      {
        path: '/invite',
        element: (
          <Suspense>
            <Invite />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '免费积分'
        }
      },
      {
        path: '/setting',
        element: (
          <Suspense>
            <Setting />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '个人中心',
          headerShow: true
        }
      },
      {
        path: '/promoter',
        element: (
          <Suspense>
            <Promoter />
          </Suspense>
        ),
        meta: {
          requiresAuth: false,
          title: '免费积分'
        }
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/" />
  }
]

const Router = () => {
  const routes = useRoutes(rootRouter)
  return routes
}

export default Router
